import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ClinicalTrialAffiliatesType } from '@dynamika-shared/types/clinicalTrialAffiliates';
import { routesPath } from '@router/routes';
import { ClinicalTrialList } from '@components/LoginSelections/ClinicalTrialList/ClinicalTrialList';
import { useQCTasksListSlice } from '@restore/QCTasksList/QCTasksList.slice';
import { useAuthSlice } from '@restore/auth/auth.slice';
import { useClinicalTrialContextSlice } from '@restore/clinicalTrialContext/clinicalTrialContext.slice';
import { useClinicalTrialAffiliatesSlice } from '@restore/clinicalTrialAffiliates/clinicalTrialAffiliates.slice';
import { useSettingsSlice } from '@restore/settings/settings.slice';
import { prepareUrl } from '@utils/routerHelpers';
import { Divider } from 'antd';
import { useFeatureFlag } from '@dynamika-shared/services/featureFlags';
import { renderQcMenuSections } from './qcRoutes';

export const QcMenu = () => {
  const userData = useAuthSlice(s => s.data);
  const navigate = useNavigate();
  const location = useLocation();
  const sidebarCollapsed = useSettingsSlice(state => state.sidebarCollapsed);
  const { QUERY_MANAGEMENT_FLAG } = useFeatureFlag();

  const [dataCT, fetchClinicalTrials] = useClinicalTrialAffiliatesSlice(
    (state, actions) => [state.data, actions.fetchClinicalTrialAffiliates]
  );
  const [fetchContext, clearData, contextData] = useClinicalTrialContextSlice(
    (state, actions) => [
      actions.fetchClinicalTrialContext,
      actions.clearData,
      state.data,
    ]
  );

  const { id: clinicalTrialId } = useParams<{
    id: string;
  }>();

  const clearQCData = useQCTasksListSlice((state, actions) => actions.clear);

  useEffect(() => {
    if (!dataCT?.length) {
      fetchClinicalTrials(null);
    }
  }, [dataCT]);

  useEffect(() => {
    if (clinicalTrialId && clinicalTrialId !== contextData?.configuration?.id) {
      const setNewContext = async (ctId: string) => {
        clearQCData();
        clearData();
        fetchContext(ctId);
      };
      setNewContext(clinicalTrialId);
    }
  }, [clinicalTrialId]);

  const handleSelectCT = (clinicalTrial: ClinicalTrialAffiliatesType) => {
    const isQueriesRoute = location.pathname.includes('/qc/queries');
    const target = isQueriesRoute
      ? prepareUrl(routesPath.qcQueries, [clinicalTrial.id])
      : prepareUrl(routesPath.qcTasks, [clinicalTrial.id]);
    navigate(target);
  };

  if (!userData?.selectedRole) {
    return null;
  }

  return (
    <div>
      {QUERY_MANAGEMENT_FLAG && (
        <>
          <ul className='list-none m-0 p-0'>
            {renderQcMenuSections(clinicalTrialId, sidebarCollapsed)}
          </ul>
          <Divider />
        </>
      )}

      <ClinicalTrialList
        clinicalTrials={dataCT}
        handleSelectCT={handleSelectCT}
        context={'menu'}
      />
    </div>
  );
};
